import { SxProps, Theme } from 'ui/mui';
import Link from 'ui/components/Link';
import { darkModeColors } from 'ui/theme/theme';

type FooterLinkProps = {
  href: string;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  target?: string;
  external?: boolean;
};

export const FooterLink = ({
  href,
  children,
  sx,
  target,
  external,
}: FooterLinkProps) => {
  return (
    <Link
      href={href}
      target={target}
      external={external}
      variant='body1'
      sx={{
        color: darkModeColors.text.primary,
        textDecoration: 'underline',
        '&:visited': {
          color: darkModeColors.text.primary,
        },
        '&:hover': {
          color: darkModeColors.text.primary,
        },
        '&:focus': {
          color: darkModeColors.text.primary,
        },
        ...sx,
      }}
    >
      {children}
    </Link>
  );
};
